angular.module('billing').factory('BillingRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        function getBillingAccount(billingRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + billingRequestDto.LoginUserPatientId + '/account').get(billingRequestDto);
        }

        function getOneTimePaymentUrl(oneTimePaymentUrlRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/one-time-payment-url').get(oneTimePaymentUrlRequestDto);
        }

        function getPaymentHistory(billingRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + billingRequestDto.LoginUserPatientId + '/payment-history').get(billingRequestDto);
        }

        function getReceipt(receiptRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + receiptRequestDto.LoginUserPatientId + '/receipt').get(receiptRequestDto);
        }

        function postConsentAnnualPayment(consentAnnualPaymentRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + consentAnnualPaymentRequestDto.LoginUserPatientId + '/consent-annual-payment/').customPOST(consentAnnualPaymentRequestDto);
        }

        function postApplyPayment(applyPaymentRequestDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + applyPaymentRequestDto.LoginUserPatientId + '/apply-aprima-payment/').customPOST(applyPaymentRequestDto);
        }

        function getStatementUrl(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + userId + '/statement').get();
        }

        var getStatementImage = function (loginUserId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;

            return restangular.one('billing/' + loginUserId + '/statement' + queryString).get();
        };

        function getLedgerUrl(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + userId + '/ledger').get();
        }

        var getLedgerImage = function (loginUserId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;

            return restangular.one('billing/' + loginUserId + '/ledger' + queryString).get();
        };

        function getAccountBalance(userId){
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + userId + '/balance').get();
        }

        function getStatementHistory(loginUserId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + loginUserId + '/statement-history').get();
        }

        var getStatementHistoryItemImage = function (loginUserId, statementBatchDetailUid, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width;

            return restangular.one('billing/' + loginUserId + '/statement-history/' + statementBatchDetailUid + '/' + queryString).get();
        };

        var getStatementHistoryItemPdf = function (loginUserId, statementBatchDetailUid) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('billing/' + loginUserId + '/statement-history/' + statementBatchDetailUid).get();
        };

        return{
            getBillingAccount: getBillingAccount,
            getPaymentHistory: getPaymentHistory,
            getReceipt: getReceipt,
            postConsentAnnualPayment: postConsentAnnualPayment,
            postApplyPayment: postApplyPayment,
            getOneTimePaymentUrl: getOneTimePaymentUrl,
            getStatementUrl: getStatementUrl,
            getStatementImage: getStatementImage,
            getLedgerUrl: getLedgerUrl,
            getLedgerImage: getLedgerImage,
            getAccountBalance: getAccountBalance,
            getStatementHistory: getStatementHistory,
            getStatementHistoryItemImage: getStatementHistoryItemImage,
            getStatementHistoryItemPdf: getStatementHistoryItemPdf
        };
    }]);

